module.exports = __webpack_public_path__ + "media/images/admin/icons/volume-2-374d26cdd53cd031ee624ec0c1ac1640.svg";